import { FIELD_EMAIL, FIELD_FIRST_NAME, FIELD_LAST_NAME } from '@components/dynamic-input-fields/src/utils';
import { DefaultFormFields } from '@components/forms/utils/create-fields-from-form-fields';
import { StandardProcessSteps } from '@constants/process-steps';

export const SINGLE_OFFLINE_SELL = 'single';
export const MULTIPLE_OFFLINE_SELL = 'multiple';

export type ProcessOfflineSalesStep = StandardProcessSteps;
export type SaleType = typeof SINGLE_OFFLINE_SELL | typeof MULTIPLE_OFFLINE_SELL | '';
export type MultiOfflineSaleAllowedFields = typeof FIELD_FIRST_NAME | typeof FIELD_LAST_NAME | typeof FIELD_EMAIL;

export interface OfflineSalesForm {
  eventId: string;
  offerId: string;
  channelId: string;
  quantity: number;
  addOns?: string[];
  saleType: SaleType;
  multiOfferText?: string;
  bookingFormFields: Partial<DefaultFormFields>;
  ticketHolderFormFields: Partial<DefaultFormFields>[];
}
